import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

export const blogPublicAPI = {
  list: (params = {}) => axios.get(`${API_BASE}/blog`, { params }),
  get: (slug) => axios.get(`${API_BASE}/blog/${encodeURIComponent(slug)}`),
  categories: () => axios.get(`${API_BASE}/blog/categories`),
};

export function blogImageURL(path) {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${BACKEND_URL}${path}`;
}
